import { colonyAPI } from '@/api';
import * as types from './mutation-types';

export default {
  getBlacklistedOriginators({ commit }) {
    commit(types.GET_BLACKLIST_ORIGINATORS_REQUEST);
    colonyAPI
      .get('interactions/blacklisted/')
      .then(response => commit(types.GET_BLACKLIST_ORIGINATORS_SUCCESS, response.data))
      .catch(error => commit(types.GET_BLACKLIST_ORIGINATORS_FAILURE, error.error));
  },
  addBlacklistOriginator({ commit, dispatch }, data) {
    commit(types.CREATE_BLACKLIST_ORIGINATOR_REQUEST);
    colonyAPI
      .post('interactions/blacklisted/', data)
      .then(response => {
        commit(types.CREATE_BLACKLIST_ORIGINATOR_SUCCESS, response.data);
        dispatch('getBlacklistedOriginators');
      })
      .catch(error => commit(types.CREATE_BLACKLIST_ORIGINATOR_FAILURE, error.error));
  },
  updateBlacklistOriginator({ commit }, originator) {
    commit(types.UPDATE_BLACKLIST_ORIGINATOR_REQUEST);
    colonyAPI
      .put(`interactions/blacklisted/${originator.id}/`, originator)
      .then(response => commit(types.UPDATE_BLACKLIST_ORIGINATOR_SUCCESS, response.data))
      .catch(error => commit(types.UPDATE_BLACKLIST_ORIGINATOR_FAILURE, error.error));
  },
  deleteBlacklistedOriginator({ commit, dispatch }, id) {
    colonyAPI
      .delete(`interactions/blacklisted/${id}/`)
      .then(() => commit(types.DELETE_BLACKLIST_ORIGINATOR_SUCCESS, id))
      .catch(error => commit(types.DELETE_BLACKLIST_ORIGINATOR_FAILURE, error.error));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/blacklist/actions.js